module.exports = __webpack_public_path__ + "media/images/front/icons/cart-a8d169407ced18a228058e120a2293ef.png";